var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createApi } from '@reduxjs/toolkit/query/react';
import { getInitialProviders } from '../../clients/hub-api/queries/initial_providers';
import { searchProviders } from '../../clients/hub-api/queries/search';
import { selectIsCompanyConnectJob } from '../slices/slice-link-params';
var baseQuery = function (_a, _b) {
    var query = _a.query;
    var getState = _b.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, _c, _d, mode, platformType, linkToken, isCompanyConnectJob, result_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    state = getState();
                    _c = state.linkParams, _d = _c.linkTokenPayload, mode = _d.mode, platformType = _d.platformType, linkToken = _c.linkToken;
                    isCompanyConnectJob = selectIsCompanyConnectJob(state);
                    if (!(query.kind === 'initial_providers')) return [3 /*break*/, 2];
                    return [4 /*yield*/, getInitialProviders(mode, linkToken)];
                case 1:
                    result_1 = _e.sent();
                    return [2 /*return*/, { data: result_1 }];
                case 2:
                    if (query.kind === 'search') {
                        return [2 /*return*/, searchProviders(mode, linkToken, {
                                searchText: query.args.searchText,
                                platformType: platformType,
                                isCompanyConnectJob: isCompanyConnectJob,
                                fromTemplateSearch: query.args.fromTemplateSearch,
                                queryParams: query.args.queryParams,
                            })];
                    }
                    // This should never be reachable as a compile-time TS error would occur
                    throw new Error("Query type not supported: ".concat(JSON.stringify(query)));
            }
        });
    });
};
// Define a service using a base URL and expected endpoints
export var hubApi = createApi({
    reducerPath: 'hubApi',
    baseQuery: baseQuery,
    endpoints: function (builder) { return ({
        getInitialProviders: builder.query({
            query: function () { return ({
                query: {
                    kind: 'initial_providers',
                },
            }); },
        }),
        search: builder.query({
            query: function (_a) {
                var searchText = _a.searchText, queryParams = _a.queryParams, fromTemplateSearch = _a.fromTemplateSearch;
                return ({
                    query: {
                        kind: 'search',
                        args: {
                            searchText: searchText,
                            queryParams: queryParams,
                            fromTemplateSearch: fromTemplateSearch || false,
                        },
                    },
                });
            },
        }),
    }); },
});
export var useGetInitialProvidersQuery = hubApi.useGetInitialProvidersQuery, useLazySearchQuery = hubApi.useLazySearchQuery;
